"use client"
import PageDrawerMobile, { PageDrawerMobileProps, PageDrawerMobileRef } from "@/components/common/PageDrawerMobile"
import XIcon from "@/components/icons/XIcon"
import { forwardRef, useImperativeHandle, useRef } from "react"


export type PopupMobileRef = {
  open: () => void,
  close: () => void,
}

type PopupMobileProps = PageDrawerMobileProps & {

}

const PopupMobile = forwardRef<PopupMobileRef, PopupMobileProps>(
  (props, ref) => {
    const refPageDrawerMobile = useRef<PageDrawerMobileRef>(null)
    const styleMap = typeof props.styles === 'function' ? undefined : props.styles

    useImperativeHandle(ref, () => {
      return {
        open: () => refPageDrawerMobile.current?.open(),
        close: () => refPageDrawerMobile.current?.close()
      }
    }, [refPageDrawerMobile.current])

    return (
      <PageDrawerMobile
        style={{ background: 'none' }}
        ref={refPageDrawerMobile}
        placement='bottom'
        maskClosable
        {...props}
        styles={{
          ...styleMap,
          body: {
            backgroundColor: '#ffffff',
            paddingBlock: '1.5rem',
            paddingInline: '1.6rem',
            height: props.hiddenHeader ? "100%" : 'calc(100% - 6.5rem)',
            ...styleMap?.body,
          },
          wrapper: {
            bottom: 0,
            boxShadow: 'none',
            borderTopLeftRadius: '1.6rem',
            borderTopRightRadius: '1.6rem',
            overflow: 'hidden',
            ...styleMap?.wrapper,
            top: 'unset'
          },
        }}
        headerProps={{
          shownRight: true,
          shownLeft: false,
          rightIcon: <XIcon style={{ color: 'rgba(16,24,40,0.88)' }} />,
          onRightClick() {
            refPageDrawerMobile.current?.close()
          },
          ...props.headerProps
        }}
      />
    )
  })

PopupMobile.displayName = 'PopupMobile'

export default PopupMobile
